<template>
    <div>
        <div>
            <img class="hbsc" src="~@public/img/hotApply/icon_zfgk.png">
        </div>
        <p class="title">长按图片，识别执法公开微信公众号</p>
    </div>
</template>

<script>
    export default {
        name: "LawMap"
    }
</script>
<style scoped>
    .hbsc {
        width: 75%;
        margin: 4.0rem 1.0rem 1.0rem 1.2rem
    }
    .title{
        font-size: 0.5rem;
        text-align: center;
        color:black;
    }
</style>